module.exports = __webpack_public_path__ + "img/tpt.03fca0cc.png";